import type { EditorScreen } from '@/store/editor/types/screen';
import type { QuizBackKind } from './quizHeader';

/**
 * Шапка квиза по экрану (слово владельца 21.10.2026, stylepack/header-back-total).
 * Вынесено из QuizScreenWizard.tsx (большой файл) — визард только зовёт эти
 * функции.
 *
 * - Mojo: кнопка «назад» в шапке есть на части экранов. Поле экрана
 *   `hideHeaderBack` гасит ТОЛЬКО её: форма кнопки на этом экране — `none`,
 *   поэтому место кнопки ровно как у шапки с `backButton: 'none'` (распорки
 *   нет); полоса, счётчик, крестик и логотип не трогаются. `hideChrome`
 *   главнее — визард проверяет его раньше.
 * - Walk-fit: счётчик «2 / 52» при 51 разобранном экране. Поле шапки
 *   `counterTotal` подменяет «всего» только в тексте счётчика; номер экрана,
 *   доля полосы и аналитика (screenIndex/screenTotal) считаются по пути.
 *
 * Нет полей — прежнее поведение.
 */

/** Форма кнопки «назад» шапки на этом экране. */
export function headerBackKind(
  kind: QuizBackKind,
  screen: Pick<EditorScreen, 'hideHeaderBack'> | undefined,
): QuizBackKind {
  return screen?.hideHeaderBack === true ? 'none' : kind;
}

/**
 * «Всего» в тексте счётчика: поле шапки, а без него — посчитанное по пути.
 * Не меньше текущего номера: при ветвлении путь бывает длиннее заданного
 * числа, и шапка не должна писать «53/52».
 */
export function headerCounterTotal(
  counterTotal: number | undefined,
  pathTotal: number,
  current: number,
): number {
  return counterTotal === undefined
    ? pathTotal
    : Math.max(counterTotal, current);
}
